import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const breakthroughs = [
  { text: 'Cancerul, bolile cardiovasculare și neurodegenerarea au fost eliminate.' },
  { text: 'Îmbătrânirea a devenit, pentru prima dată în istorie, o alegere, nu o inevitabilitate.' },
  { text: 'Energia de fuziune a devenit atât de abundentă încât a încetat să mai fie măsurată.' },
  { text: 'Conștiința putea fi încărcată, extinsă și partajată între minți.' },
  { text: 'Sistemul solar nu a fost doar explorat — a fost locuit.' },
];

const WorldQuantumRo = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-brand-accent/5 via-transparent to-transparent"></div>
    <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
      <SectionHeading title="Ce a Făcut Posibilă Trezirea Cuantică" subtitle="Metamorfoza" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mb-10"
      >
        <p className="text-gray-300 leading-relaxed text-lg text-center mb-4">
          În <span className="text-brand-accent font-semibold">2071</span>, Dr. Elena Vasquez a creat primul procesor cuantic stabil într-un laborator din Zürich. Ceea ce a urmat nu a fost doar progres tehnologic — a fost o metamorfoză civilizațională. În decurs de două secole:
        </p>
      </motion.div>

      <div className="space-y-4">
        {breakthroughs.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="flex items-start gap-4 bg-brand-dark border border-white/5 rounded-xl p-5 hover:border-brand-accent/20 transition-colors"
          >
            <span className="mt-1 w-2 h-2 rounded-full bg-brand-accent flex-shrink-0 shadow-[0_0_8px_rgba(234,179,8,0.6)]"></span>
            <p className="text-gray-300 leading-relaxed">{item.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WorldQuantumRo;